module.exports = __webpack_public_path__ + "static/media/google-btn.c0ed6f5d.svg";